import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomStyleDirective } from './custom-style.directive';
import { LoginRegisterModule } from './pages/login-register/login-register.module';
import {
  AppConfigModule,
  AppConfigService,
} from './helper_services/app-config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './helper_services/error.interceptor';
import { JwtInterceptor } from './helper_services/jwt.interceptor';
import { AlertComponent } from './services/alert/directives/alert.component';
import { SpinnerComponent } from './services/spinner/directives/spinner.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    CustomStyleDirective,
    AlertComponent,
    SpinnerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LoginRegisterModule,

    ModalModule.forRoot(),
    CarouselModule.forRoot(),
   
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    DatePipe,
    AppConfigService,
    AppConfigModule.init(),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
